import { render, staticRenderFns } from "./InfoCards.vue?vue&type=template&id=f6d73b82&scoped=true&"
import script from "./InfoCards.vue?vue&type=script&lang=js&"
export * from "./InfoCards.vue?vue&type=script&lang=js&"
import style0 from "./InfoCards.vue?vue&type=style&index=0&id=f6d73b82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d73b82",
  null
  
)

export default component.exports